import {
  MemoryLinkValue,
  MemoryShowIn,
  MemoryValue,
  StepCheck,
  StepCheckSwitch,
} from '../../../components/pages/Book/MemoryBank/memoryBankTypes';
import { AudioStepSettingsType } from '../audio/AudioStepSettingsType';
import { Character } from '../character/Character';
import { ExpressionValue } from '../character/ExpressionValue';
import { VideoSettings } from '../video/video';
import { AnswerStep } from './AnswerStep';
import { HubOption, HubSettings } from './HubOption';

export enum StepTypes {
    Dialogue = 1,
    Narrator = 2,
    Choice = 3,
    Ending = 5,
    Result = 6,
    PlayerSelect = 7,
    Texting = 8,
    Thinking = 9,
    Reaction = 10,
    Check = 11,
    Remember = 12,
    Achieve = 13,
    Video = 14,
    Random = 15,
    Hub = 16,
}

export const MEMORY_TECHNICAL_STEP_TYPES: readonly StepTypes[] = [
  StepTypes.Check,
  StepTypes.Remember,
  StepTypes.Random,
];

export const MEMORY_MUTATING_STEP_TYPES: readonly StepTypes[] = [
  StepTypes.Remember,
  StepTypes.Random,
];

export function isMemoryTechnicalStepType(stepTypeId: StepTypes | number | null | undefined): boolean {
  return MEMORY_TECHNICAL_STEP_TYPES.includes(Number(stepTypeId) as StepTypes);
}

export function isMemoryMutatingStepType(stepTypeId: StepTypes | number | null | undefined): boolean {
  return MEMORY_MUTATING_STEP_TYPES.includes(Number(stepTypeId) as StepTypes);
}

export enum BranchStepMemoryActionType {
    Set = 'set',
    Increase = 'increase',
    Decrease = 'decrease',
    View = 'view',
}

export type BranchStepMemoryAction =
  | { variableId: number; type: BranchStepMemoryActionType.Set; value: MemoryValue | MemoryLinkValue }
  | { variableId: number; type: BranchStepMemoryActionType.Increase; value: MemoryValue | MemoryLinkValue }
  | { variableId: number; type: BranchStepMemoryActionType.Decrease; value: MemoryValue | MemoryLinkValue }
  | { variableId: number; type: BranchStepMemoryActionType.View; value: Array<MemoryShowIn> };

export enum BranchStepMemoryRollType {
    Set = 'set',
    Increase = 'increase',
    Decrease = 'decrease',
    Dice = 'dice',
}

export type BranchStepMemoryRoll =
  | { variableId: number; type: BranchStepMemoryRollType.Set; min: MemoryValue; max: MemoryValue; modifier?: number }
  | { variableId: number; type: BranchStepMemoryRollType.Increase; min: MemoryValue; max: MemoryValue; modifier?: number }
  | { variableId: number; type: BranchStepMemoryRollType.Decrease; min: MemoryValue; max: MemoryValue; modifier?: number }
  | { variableId: number; type: BranchStepMemoryRollType.Dice; diceNotation: string };

export type BranchStep = {
    id: number;
    index: null;
    stepTypeId: StepTypes;
    subType: string | null;
    text: string;
    characterId: number | null;
    characterRelationship: string | null;
    // currencyToggleSettings: raw DB column (getBranchesRaw.js:707); string in practice.
    currencyToggleSettings?: string | null;
    characterExpressionId: number;
    character?: Character;
    characterPlacementSide: 'default' | 'left' | 'right';
    branchId: number;
    backgroundLocationId?: number | null;
    data: Record<string, unknown>; // {} | [];
    expression?: {
        id: number;
        title: string;
        value: ExpressionValue;
        def: boolean;
        createdAt: string; // UTC format date
        updatedAt: string; // UTC format date
    };
    answers: AnswerStep[];
    wordCount: number;
    switch?: StepCheckSwitch[];
    action?: BranchStepMemoryAction;
    roll?: BranchStepMemoryRoll;
    check?: StepCheck;
    speakerMemoryId?: number;
    achievementId?: number;
    // achievementDescription: companion text stored in additionalData (story_branch.js:293).
    achievementDescription?: string;
    audio?: AudioStepSettingsType;
    stepAudios?: AudioStepSettingsType;
    video?: { id: number; url: string; title: string; videoSettings?: VideoSettings };
    hubOptions?: HubOption[];
    hubSettings?: HubSettings;
}
